import * as THREE from 'three';
import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js';
import { OutputPass } from 'three/addons/postprocessing/OutputPass.js';
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js';
import { UnrealBloomPass } from 'three/addons/postprocessing/UnrealBloomPass.js';

export class BloomPipeline {
  private readonly composer: EffectComposer;
  private readonly bloom: UnrealBloomPass;

  constructor(
    private readonly renderer: THREE.WebGLRenderer,
    private readonly scene: THREE.Scene,
    private readonly camera: THREE.Camera,
  ) {
    this.composer = new EffectComposer(renderer);
    this.composer.addPass(new RenderPass(scene, camera));
    this.bloom = new UnrealBloomPass(new THREE.Vector2(window.innerWidth, window.innerHeight), 0, 0.45, 0.82);
    this.composer.addPass(this.bloom);
    this.composer.addPass(new OutputPass());
  }

  render(deltaSeconds: number): void {
    if (this.bloom.strength <= 0) this.renderer.render(this.scene, this.camera);
    else this.composer.render(deltaSeconds);
  }
  resize(width: number, height: number): void { this.composer.setSize(width, height); }
  setPixelRatio(pixelRatio: number): void { this.composer.setPixelRatio(pixelRatio); }
  setStrength(strength: number): void { this.bloom.strength = strength; }
  dispose(): void { this.composer.dispose(); }
}
